import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=21089b84&scoped=true&"
import script from "./Builder.vue?vue&type=script&lang=js&"
export * from "./Builder.vue?vue&type=script&lang=js&"
import style0 from "./Builder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Builder.vue?vue&type=style&index=1&id=21089b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21089b84",
  null
  
)

export default component.exports